/// <amd-module name="Wit/Common/SprintSettings/Utils/SaveSettingsUtils" />
import { TeamContext } from "Tfs/Platform/Contracts/Core";
import { IVssPageContext } from "VSS/Platform/Context";
import { BoardCardRuleSettings } from "Wit/Clients/Work/Contracts/Work";
import { IWorkRestClient } from "Wit/Clients/Work/RestClient/Work";
import { IBoardFieldSettings } from "Wit/Common/WitSettingsViews/Components/CardSettingsViews/BoardFieldSettings";
import { getStyleSettingsAsStyleRules, IStyleService } from "Wit/Common/WitSettingsViews/Components/StylesTable/StyleService";

export async function saveTaskboardFieldSettings(
    pageContext: IVssPageContext,
    teamContext: TeamContext,
    boardFieldSettings: IBoardFieldSettings
): Promise<void> {
    const workClient = pageContext.getRestClient<IWorkRestClient>("IWorkRestClient");
    await workClient.updateTaskboardCardSettings(boardFieldSettings.getServerFieldSettings(), teamContext);
}

export async function saveCardStyleSettings(pageContext: IVssPageContext, teamContext: TeamContext): Promise<void> {
    const styleService = pageContext.getService<IStyleService>("IStyleService");
    const boardCardRuleSettings = {
        rules: {
            ["fill"]: getStyleSettingsAsStyleRules(styleService.rows.value)
        }
    } as unknown as BoardCardRuleSettings;

    const workClient = pageContext.getRestClient<IWorkRestClient>("IWorkRestClient");
    await workClient.updateTaskboardCardRuleSettings(boardCardRuleSettings, teamContext);
}
